import { Tooltip } from 'react-tooltip';
import './HoverContainer.scss';

const HoverContainer = (props: Parameters<typeof Tooltip>[0]) => {
	return <Tooltip className="tooltip" {...props} />;
};

export default HoverContainer;
